type Service = {
  icon: string;
  title: string;
  desc: string;
};

const SERVICES: Service[] = [
  {
    icon: "ri-list-check-3",
    title: "情報整理",
    desc: "手元の資料から、掲載する内容を整理します。",
  },
  {
    icon: "ri-layout-3-line",
    title: "デザイン・制作",
    desc: "目的に合わせた、スマホでも見やすいページに仕上げます。",
  },
  {
    icon: "ri-rocket-line",
    title: "公開サポート",
    desc: "表示やリンクを確認し、公開まで対応します。",
  },
];

export default function ServiceContent() {
  return (
    <section id="service" className="scroll-mt-20 bg-white py-16 md:py-24">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="max-w-2xl">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-lime-600">Service</p>
          <h2 className="mt-3 font-heading text-3xl font-black leading-tight text-navy-950 md:text-5xl">
            必要な情報を整理して、公開できる形に。
          </h2>
          <p className="mt-5 text-base leading-relaxed text-navy-600">
            素材がすべてそろっていなくても、まずはご相談ください。
            <br />
            手元にあるものから、一緒に整えていきます。
          </p>
        </div>

        <div className="mt-12 grid gap-6 md:grid-cols-3 md:gap-8">
          {SERVICES.map((service, i) => (
            <div
              key={service.title}
              className={`border-t-2 p-6 ${
                i === 1 ? "border-lime-400 bg-cream" : "border-navy-100"
              }`}
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-navy-900 text-lime-400">
                <i className={`${service.icon} text-xl`} aria-hidden="true" />
              </span>
              <h3 className="mt-6 font-heading text-xl font-black text-navy-950">{service.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-navy-600">{service.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}